// extracted by mini-css-extract-plugin
export default {"variantTabContainer":"XUK1nVlu5B","variantTab":"uvJZ_HK6eE","variantItem":"YLiSxPCrG0","active":"r8sLQ8REvK"};